import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createNewFrequency } from "../../../api/wordsApi";
import { COUNTER_DATA } from "./queryKeys";

export const useCreateNewFrequencyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => createNewFrequency(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [COUNTER_DATA] });
    },
  });
};